import { ReviewPost } from '../types/review';

// Import all review posts from the posts directory
import candyAiReview from './posts/candy-ai-review-2026';
import kupidAiReview from './posts/kupid-ai-review';
import luvrAiReview from './posts/luvr-ai-review';
import lovescapeAiReview from './posts/lovescape-ai-review';
import nomiAiReview from './posts/nomi-ai-review';
import herahavenAiReview from './posts/herahaven-ai-review';
import nectarAiReview from './posts/nectar-ai-review';
import muahAiReview from './posts/muah-ai-review';
import botifyAiReview from './posts/botify-ai-review';
import replikaAiReview from './posts/replika-ai-review';
import charstarAiReview from './posts/charstar-ai-review';
import gptgirlfriendReview from './posts/gptgirlfriend-review';
import spicyChatAiReview from './posts/spicy-chat-ai-review';
import romanticAiReview from './posts/romantic-ai-review';
import dreamgfReview from './posts/dreamgf-review';
import soulgenAiReview from './posts/soulgen-ai-review';
import fantasygfReview from './posts/fantasygf-review';
import uncensyReview from './posts/uncensy-review';
import characterAiReview from './posts/character-ai-review';
import darlinkAiReview from './posts/darlink-ai-review';
import ourdreamAiReview from './posts/ourdream-ai-review';
import mylovelyAiReview from './posts/mylovely-ai-review';
import goloveAiReview from './posts/golove-ai-review';
import swipeyAiReview from './posts/swipey-ai';
import flirtcamAiReview from './posts/flirtcam-ai-review';
import lovelAiReview from './posts/lovel-ai-review';
import joiAiReview from './posts/joi-ai-review';
import camsodaAiReview from './posts/camsoda-ai-review';
import cherrypopAiReview from './posts/cherrypop-ai-review';
import nextpartAiReview from './posts/nextpart-ai-review';
import lollipopChatReview from './posts/lollipop-chat-review';
import eternalAiReview from './posts/eternal-ai-review';
import newAiPlatformReviews from './posts/new-ai-platform-reviews';
import { toAffiliateHref } from '../lib/affiliateLinks';
import { getPlatformCategories, getPlatformRating } from '../utils/bestAIGirlfriendRatings';
import { alignMetaScore, alignOverallRankCopy, alignScoreCopy } from '../utils/reviewScoreCopy';
import { getRank } from '../data/platformRanking';
import { HANDOFF_REVIEW_FAQS } from '../data/handoffReviewFaqs';
import { stripRemovedBesticleLinks } from '../data/removedBesticles';

// Combine all reviews in a single array - newest first based on date
const reviews: ReviewPost[] = [
  ...newAiPlatformReviews,
  eternalAiReview,        // November 4, 2026
  lollipopChatReview,     // October 29, 2026
  nextpartAiReview,       // October 29, 2026
  cherrypopAiReview,      // October 28, 2026
  camsodaAiReview,        // October 21, 2026
  joiAiReview,            // October 21, 2026
  lovelAiReview,          // October 21, 2026
  flirtcamAiReview,       // October 21, 2026
  swipeyAiReview,         // June 20, 2026
  goloveAiReview,         // February 26, 2026
  mylovelyAiReview,       // February 24, 2026
  darlinkAiReview,        // February 8, 2026
  ourdreamAiReview,      // February 8, 2026
  characterAiReview,      // January 31, 2026
  uncensyReview,          // January 20, 2026
  fantasygfReview,        // January 15, 2026
  dreamgfReview,          // August 18, 2025
  replikaAiReview,        // August 13, 2025
  botifyAiReview,        // August 10, 2025
  charstarAiReview,       // August 7, 2025
  soulgenAiReview,       // July 24, 2025
  nectarAiReview,        // July 12, 2025
  muahAiReview,          // July 11, 2025
  lovescapeAiReview,     // July 9, 2025
  nomiAiReview,          // July 9, 2025
  herahavenAiReview,     // July 5, 2025
  luvrAiReview,          // July 4, 2025
  kupidAiReview,         // July 3, 2025
  candyAiReview,         // July 3, 2025
  romanticAiReview,      // September 1, 2026
  gptgirlfriendReview,   // June 15, 2025
  spicyChatAiReview,      // May 24, 2025

].sort((a, b) => {
  // Ensure sorting by date, newest first
  return new Date(b.date).getTime() - new Date(a.date).getTime();
}).map((review) => {
  const platformRating = getPlatformRating(review.slug);
  const platformCategories = getPlatformCategories(review.slug);

  const score = platformRating || review.rating;
  // Overall rank always comes from platformRanking.ts, never the post file
  const rank = getRank(review.slug);

  return {
    ...review,
    rank: rank ?? undefined,
    title: alignOverallRankCopy(review.title, rank),
    metaTitle: alignOverallRankCopy(review.metaTitle, rank),
    affiliateLink: toAffiliateHref(review.affiliateLink, review.slug),
    rating: score,
    schemaRating: score,
    content: stripRemovedBesticleLinks(alignScoreCopy(review.content, score)),
    metaDescription: alignOverallRankCopy(alignMetaScore(review.metaDescription, score), rank),
    verdict: review.verdict ? alignScoreCopy(review.verdict, score) : review.verdict,
    promoBadge: review.promoBadge === 'RUNNER UP' ? undefined : review.promoBadge,
    ...(platformCategories.length > 0 ? { ratingCategories: platformCategories } : {}),
    ...(!review.faqs?.length && HANDOFF_REVIEW_FAQS[review.slug]
      ? { faqs: HANDOFF_REVIEW_FAQS[review.slug] }
      : {}),
  };
});

export default reviews;
